// extracted by mini-css-extract-plugin
module.exports = {"root":"segmented-control-item_root__1vLnt","label":"segmented-control-item_label__zeWLT"};